import React from "react";
import styled from "styled-components";
import Table from "../../shared/ui/Table";
import { SectionWrapper } from "../../../styles/common";
import { NURI_PARAM } from "../../../constants";

const NuriEvent = ({ NURIPROPS, title }) => {
  return (
    <SectionWrapper>
      <h2 className="title">{title}</h2>
      <h3 className="subtitle">Conjunction Assessment Report</h3>
      <main className="content">
        <RadioButtonWrapper>
          <span>Showing the First {NURI_PARAM.LIMIT} Entries | </span>
          <span>Sorted by :</span>
          <input
            type="radio"
            id="TCA"
            name="sort"
            onChange={() => NURIPROPS.setSelectedEvent("TCA")}
            checked={NURIPROPS.selectedEvent === "TCA"}
          />
          <label htmlFor="TCA">TCA</label>
          <input
            type="radio"
            id="DCA"
            name="sort"
            onChange={() => NURIPROPS.setSelectedEvent("DCA")}
            checked={NURIPROPS.selectedEvent === "DCA"}
          />
          <label htmlFor="DCA">DCA</label>
        </RadioButtonWrapper>
        <Table
          tableHeader={NURIPROPS.NURI_TABLE_HEADER}
          tableData={NURIPROPS.nuriTableData}
          handleSelectData={NURIPROPS.handleSelectNuriData}
          // selectedRow={NURIPROPS.selectedRow}
          // setSelectedRow={NURIPROPS.setNuri}
        />
      </main>
    </SectionWrapper>
  );
};

export default NuriEvent;

const RadioButtonWrapper = styled.div`
  width: 100%;
  padding: 1rem;
  box-sizing: border-box;
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.9rem;
  input[type="radio"] {
    margin: 0 0 0 0.5rem;
  }
`;
